import windowResizeFactory from './window-resize';

export default windowResizeFactory;
export { windowResizeFactory };
